import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-person-remove",
  "use": "icon-si-glyph-person-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-person-remove\" id=\"icon-si-glyph-person-remove\"><title>180</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 1.000000)\" fill=\"#434343\"><path d=\"M10.985,3.044 C10.985,4.715 9.649,7.907 8.002,7.907 C6.354,7.907 5.016,4.715 5.016,3.044 C5.016,1.375 6.354,0.021 8.002,0.021 C9.649,0.021 10.985,1.375 10.985,3.044 L10.985,3.044 Z\" class=\"si-glyph-fill\" /><path d=\"M9.938,11.982 L15.761,11.982 C15.314,10.398 14.168,8.029 11.703,8.029 C10.849,9.188 8.011,9.485 8.011,9.485 C8.011,9.485 5.108,9.199 4.252,8.055 C0.156,8.055 0.031,13.978 0.031,13.978 L9.937,13.978 L9.937,11.982 L9.938,11.982 Z\" class=\"si-glyph-fill\" /><rect x=\"11\" y=\"13\" width=\"4.937\" height=\"0.972\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-person-remove.svg
// module id = Mzv8
// module chunks = 62